<template>
  <div ref="projectTableWrapper" :class="`project-table-wrapper ${className}`">
    <ProjectSearchBar
      v-if="showSearch"
      :on-search="setQuery"
      class-name="col-0"
      :company-name="companyName"
      :company-show-search="companyShowSearch"
    />
    <el-table
      ref="table"
      :data="list"
      :height="tableHeight"
      class="col-1"
      border
      size="mini"
      tooltip-effect="dark"
      highlight-current-row
      @sort-change="handleSort"
      @selection-change="onSelect"
    >
      <el-table-column v-if="!radishId" type="index" align="center" width="45" />
      <el-table-column prop="编号" label="项目编号" show-overflow-tooltip min-width="100" />
      <el-table-column label="操作" align="center" width="45">
        <template slot-scope="scope">
          <a :id="`h${scope.row._id}`" class="popper-btn" @click="showDropdown(scope.row, `h${scope.row._id}`)">
            <i class="el-icon-setting" />
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="Pipeline" width="70">
        <template slot-scope="scope">
          <a :id="`p${scope.row._id}`" class="pointer popper-btn" @click="showPipeline(scope.row, `p${scope.row._id}`)"
            >查看</a
          >
        </template>
      </el-table-column>
      <el-table-column v-if="showSelection" type="selection" width="45" />
      <el-table-column prop="files" label="附件" align="center" width="45">
        <template slot-scope="scope">
          <a :id="`f${scope.row._id}`" class="pointer popper-btn" @click="showFiles(scope.row, `f${scope.row._id}`)">
            {{ (scope.row.files && scope.row.files.length) || 0 }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="radishId" label="意向" prop="意向">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.意向"
            size="mini"
            class="color-select"
            :style="{ background: scope.row.意向 ? yiOptions[scope.row.意向] : '' }"
            @change="changeYi(scope.row, scope.row.意向)"
          >
            <el-option
              v-for="(color, val) in yiOptions"
              :key="val"
              :label="val"
              :value="val"
              :style="{ background: color }"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column v-if="radishId" label="进展" width="100">
        <template slot-scope="scope">
          <div @click="onClickStatus(scope.row)">
            {{
              scope.row['状态']
                ? scope.row['状态'].tag + (scope.row['状态'].detail ? `（${scope.row['状态'].detail}）` : '')
                : ''
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="客户公司" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <a class="pointer col-0" @click="onClickName('公司', scope.row['客户公司'])">
            {{ scope.row['客户公司'] || '--' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column sortable="custom" prop="部门" label="部门" min-width="120" />
      <el-table-column label="项目名称" sortable="custom" show-overflow-tooltip min-width="160">
        <template slot-scope="scope">
          <input
            v-if="editing === scope.row._id"
            :value="scope.row['项目名称']"
            type="text"
            autofocus
            class="cell-edit-input"
            @blur="e => onChangeName(scope.row, e.target.value)"
          />
          <a
            v-else
            :href="`#/project20/${scope.row.pid || scope.row._id}`"
            target="_blank"
            @dblclick="onEdit(scope.row.pid || scope.row._id)"
            >{{ scope.row['项目名称'] || '--' }}</a
          >
          <el-tag v-if="scope.row['独家']" class="cell-multi-item" size="mini">独家</el-tag>
          <el-tag v-if="showAdvanced(scope.row)" class="cell-multi-item" size="mini">高端</el-tag>
          <el-tag v-if="scope.row['保密']" class="cell-multi-item" size="mini">保密</el-tag>
          <el-tag v-if="scope.row['新增']" class="cell-multi-item" size="mini">新增</el-tag>
          <el-tag v-if="scope.row['替代']" class="cell-multi-item" size="mini">替代</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="职能模块" sortable="custom" label="职能模块" min-width="120" />
      <el-table-column label="项目状态" sortable="custom" width="100">
        <template slot-scope="scope">
          <a
            :id="`status_${scope.row._id}`"
            class="popper-btn"
            @click="showStatus(scope.row, `status_${scope.row._id}`)"
          >
            {{ scope.row['项目状态'] }} <i class="el-icon-arrow-down" />
          </a>
        </template>
      </el-table-column>
      <el-table-column prop="地域" sortable="custom" label="地域" show-overflow-tooltip min-width="100" />
      <el-table-column prop="优先级" sortable="custom" label="优先级" width="120">
        <template slot-scope="scope">
          <i v-for="n in 5" :key="n" :class="n <= scope.row['优先级'] ? 'el-icon-star-on' : 'el-icon-star-off'" />
        </template>
      </el-table-column>
      <el-table-column prop="客户开发" sortable="custom" label="客户开发" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['客户开发'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['客户开发']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['客户开发'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目对接" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目对接'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目对接']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目对接'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目经理" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目经理'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目经理']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目经理'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="项目成员" sortable="custom" min-width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          <div v-if="Array.isArray(scope.row['项目成员'])" class="cell-multi">
            <span v-for="(val, index) in scope.row['项目成员']" :key="index" class="cell-multi-item">{{ val }}</span>
          </div>
          <span v-else>{{ scope.row['项目成员'] || '--' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="开始时间" show-overflow-tooltip sortable="custom" width="130">
        <template slot-scope="scope">{{ moment(scope.row.startTime) || moment(scope.row.createdAt) || '--' }}</template>
      </el-table-column>
      <el-table-column label="进展天数" sortable="custom" width="95">
        <template slot-scope="scope">{{ passed(scope.row.startTime || scope.row.createdAt) || '--' }}</template>
      </el-table-column>
      <el-table-column label="预计推荐时间" show-overflow-tooltip sortable="custom" width="120">
        <template slot-scope="scope">{{ moment(scope.row.indroduceTime) || '--' }}</template>
      </el-table-column>
      <el-table-column v-if="!simple" label="实际推荐时间" show-overflow-tooltip width="100">
        <template slot-scope="scope">{{ moment(scope.row['实际推荐时间']) || '--' }}</template>
      </el-table-column>
      <el-table-column label="高概率offer人选" show-overflow-tooltip width="120">
        <template slot-scope="scope">
          <span v-for="radish in scope.row.高概率" :key="radish.rid"> {{ radish.姓名 }}、 </span>
        </template>
      </el-table-column>
      <el-table-column label="近期操作" show-overflow-tooltip width="130">
        <template slot-scope="scope">
          {{ scope.row['近期操作'] }}
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" prop="项目人才" label="项目人才" width="100" align="center" />
      <el-table-column v-if="!simple" prop="Y" label="Y" width="60" align="center" />
      <el-table-column v-if="!simple" prop="F" label="F" width="60" align="center" />
      <el-table-column v-if="!simple" prop="N" label="N" width="60" align="center" />
      <el-table-column v-if="!simple" prop="未沟通" label="未沟通" width="90" align="center" />
      <el-table-column v-if="!simple" prop="已推荐" label="已推荐" width="90" align="center" />
      <el-table-column v-if="!simple" label="面试" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('面试', scope.row['面试'])">
            {{ scope.row['面试'] ? scope.row['面试'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="终面" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('终面', scope.row['终面'])">
            {{ scope.row['终面'] ? scope.row['终面'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="offer" width="80" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('offer', scope.row['offer'])">
            {{ scope.row['offer'] ? scope.row['offer'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column v-if="!simple" label="到岗" width="70" align="center">
        <template slot-scope="scope">
          <a @click="showPipelineDetail('到岗', scope.row['到岗'])">
            {{ scope.row['到岗'] ? scope.row['到岗'].length : '0' }}
          </a>
        </template>
      </el-table-column>
      <el-table-column
        v-if="!simple"
        label="auc_score"
        prop="auc_score"
        width="100"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[100, 200, 500]"
      :page-size="pageSize"
      :total="total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChange"
      @current-change="pageChange"
    />
    <ProjectFeedback :visible.sync="feedbackVisible" :project="project" />
    <departmentOchart v-if="department" ref="departmentOchart" :company-name="companyName" :department="department" />
    <Popper
      :id="radishId"
      :visible.sync="popperVisible"
      :target-id="popperTarget"
      container="projectTableWrapper"
      class-name="shadow"
    >
      <FileTable
        v-if="popperType === 'files'"
        :files="files"
        :paginate="false"
        :height="FileTableHeight"
        width="700px"
      />
      <ProjectPipeline v-if="popperType === 'pipeline'" :data="pipelineData" />
      <div v-if="popperType === 'dropdown'" class="dropdown-popper">
        <a :href="`#/project20/${project.pid || project._id}`" class="item" target="_blank">进入项目</a>
        <div v-if="radishId" class="item" @click="showRadishPortrait">岗位匹配度</div>
        <!-- <div class="item" @click="onePiece">生成悬赏</div> -->
        <div class="item" @click="generatePic(project)">生成图片</div>
        <div class="item" @click="feedbackVisible = true">客户反馈</div>
        <div class="item">
          添加人选 <i class="el-icon-arrow-right" />
          <div class="sub-item shadow">
            <div class="item" @click="addRadish">添加项目人选</div>
            <!-- <div class="item" @click="openDrawer('radish')">从人才库选人</div>
            <div class="item" @click="openDrawer('project')">从同类项目选人</div>
            <div class="item" @click="jumpToCompany">从目标公司选人</div> -->
            <div class="item" @click="oneKeyMatch('1')">一键匹配</div>
            <div class="item" @click="oneKeyMatch('2')">二键匹配</div>
            <div class="item" @click="oneKeyMatch('3')">三键匹配</div>
            <div class="item" @click="recommendMatch(project)">智能匹配</div>
          </div>
        </div>
        <!-- <div class="item" @click="openDrawer('finalRadish')">项目复盘</div> -->
        <el-popover v-model="projectReportShow" placement="right" width="800" trigger="click">
          <div>
            <p>
              请点击勾选O，选择你要使用的项目报告类型：<peixun
                type="10"
                style="display:inline-block;margin-left:5px;position:relative;top:3px;"
              ></peixun>
            </p>
            <div class="flex-row">
              <div class="col-1 pd10" @click="reportType = 'mapping'">
                <el-radio v-model="reportType" label="mapping">人选mapping报告</el-radio>
                <p class="ft-gray">自行选择需要的人选字段，并形成报告。</p>
                <div><img src="../../../assets/images/project_mapping.png" class="img_max" /></div>
              </div>
              <div class="col-1 pd10" @click="reportType = 'report'">
                <el-radio v-model="reportType" label="report">搜索进度报告</el-radio>
                <p class="ft-gray">根据项目推进情况，自动进行统计，形成进度报告。</p>
                <div><img src="../../../assets/images/project_report.png" class="img_max" /></div>
              </div>
            </div>
            <div class="text_right">
              <!-- <a :href="`#/project/${project.pid || project._id}/${reportType}`" class="btn_default" target="_blank"
                >生成报告</a
              > -->
              <span class="btn_default" @click="getReport">生成报告</span>
            </div>
          </div>
          <div slot="reference" class="item" @click="generateProjectReport">生成项目报告</div>
        </el-popover>
        <div class="item" @click="copyProject">复制项目</div>
        <div class="item" @click="showProjectDetail">详情</div>
        <div v-if="showDeskfollowBtn()" class="item" @click="deleteDesktopFollow">取消本周重点</div>
        <div v-else class="item" @click="addDesktopFollow">设置为本周重点</div>
        <div v-if="canRemove" class="item ft-danger" @click="removeProject(project.pid || project._id)">删除</div>
      </div>
      <div v-if="popperType === 'status'" class="dropdown-popper">
        <div v-for="(status, i) in projectStatus" :key="i" class="item" @click="onChangeStatus(status)">
          {{ status }}
        </div>
      </div>
    </Popper>
    <ProjectDetailInfo
      v-if="projectDetailInfoVisible"
      :project-id="project._id"
      :on-close="
        () => {
          projectDetailInfoVisible = false
        }
      "
      class="fullscreen_wrapper"
    />
    <interviewListDialog ref="interviewListDialog"></interviewListDialog>
    <PipelineDetail
      :visible.sync="pipelineDetailVisible"
      :title="pipelineDetailType"
      :data="pipelineDetailData"
      :merge-radish="mergeRadish"
    ></PipelineDetail>
    <generatePic ref="generatePic" />
  </div>
</template>

<script>
import { departmentOchart } from '../../../company'
import { FileTable } from '../../../file'
import { projectStatus, sortKeyFormat } from '../constant/type'
import ProjectSearchBar from './ProjectSearchBar.vue'
import ProjectPipeline from './ProjectPipeline.vue'
import ProjectFeedback from './ProjectFeedback.vue'
import Popper from './Popper.vue'
import ProjectDetailInfo from './ProjectDetailInfo.vue'
import interviewListDialog from '../../../radish/src/dialog/interviewlist-dialog'
import { onePiece, oneKeyMatch, recommendMatch, removeProject } from '../constant/utils'
import PipelineDetail from '../dialog/PipelineDetail.vue'
import generatePic from '../dialog/generatePic.vue'
// 组件半启用，radish-detail还有使用

const dateFormat = require('dateformat')
// TODO refactor
export default {
  components: {
    ProjectSearchBar,
    ProjectPipeline,
    ProjectFeedback,
    Popper,
    ProjectDetailInfo,
    interviewListDialog,
    FileTable,
    departmentOchart,
    PipelineDetail,
    generatePic,
  },
  props: {
    simple: { type: Boolean, default: false },
    radishId: { type: String, default: undefined },
    height: { type: [String, Number], default: undefined },
    className: { type: String, default: '' },
    showSelection: { type: Boolean, default: false },
    onSelect: { type: Function, default: () => {} },
    defaultQuery: { type: Object, default: undefined },
    showSearch: { type: Boolean, default: false },
    companyShowSearch: { type: Boolean, default: false },
    companyName: { type: String, default: undefined },
  },
  data() {
    return {
      list: [],
      page: 1,
      pageSize: 100,
      total: 0,
      query: {},
      loading: false,
      tableHeight: undefined,
      pipelineData: undefined,
      feedbackVisible: false,
      department: '',
      editing: '',
      files: [],
      dropdownVisible: false,
      pipelineVisible: false,
      project: {},
      sort: {},
      popperVisible: false,
      popperTarget: '',
      popperType: '',
      FileTableHeight: undefined,
      projectDetailInfoVisible: false,
      pipelineDetailType: '',
      pipelineDetailData: [],
      pipelineDetailVisible: false,
      reportType: 'mapping',
      yiOptions: { Y: '#f99', N: '#ffc', F: '#ccf' },
      projectReportShow: false,
    }
  },
  computed: {
    canRemove() {
      if (!window.app.user) return false
      return (
        (window.app.user['角色'] && window.app.user['角色'].includes('管理员')) ||
        (this.project && this.project['项目经理'] && this.project['项目经理'].includes(window.app.user.account))
      )
    },
    app() {
      return window.app
    },
    projectStatus() {
      return projectStatus
    },
    removeProject() {
      return removeProject
    },
    onePiece() {
      return onePiece
    },
  },
  watch: {
    height: {
      handler(val, oldVal) {
        this.tableHeight = val
      },
      immediate: true,
    },
    radishId(val) {
      this.getProjects()
    },
    defaultQuery: {
      handler(val) {
        if (val) this.query = val
      },
      immediate: true,
    },
    companyName: {
      handler(val, oldVal) {
        const query = val ? Object.assign({}, this.query, { 客户公司: val }) : this.query
        this.setQuery(query)
      },
      immediate: true,
    },
  },
  mounted() {
    this.initHeight()
  },
  methods: {
    async getReport() {
      const { project } = this
      if (this.reportType === 'report') {
        const loading = this.$loading({
          lock: true,
          text: '正在获取项目进展报告，请稍等...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        })
        try {
          const res = await app.service('project').getProjectReport({
            pid: project.pid || project._id,
          })
          if (res && res.status === 'success' && res.data) {
            app.root.$refs.ProjectReportEditor.open({
              url: res.data.url,
              md5: res.data.md5,
              documentType: res.data && res.data.documentType,
              fileType: res.data && res.data.fileType,
              originalname: res.data && res.data.originalname,
            })
          } else this.$message.error(res.msg)
        } catch (e) {
          console.error(e)
          this.$message.error(`生成项目搜索进度报告出错`)
        }
        loading.close()
      } else {
        app.root.$refs.MappingReportChooseHeaderDialog.open(project.pid || project._id)
      }
    },
    openTrainingVideo() {
      app.root.$refs.TrainingVideoDialog.open('mapping')
    },
    generatePic(project) {
      this.$refs.generatePic.open(project)
    },
    showAdvanced(project) {
      const jobRank = project['职级'] || []
      return jobRank.includes('1') || jobRank.includes('2')
    },
    openRadish(radish) {
      window.open(`${window.frontend}/#/radish-detail-blank/${radish.rid}`, '_blank')
    },
    onClickStatus(item) {
      this.$refs.interviewListDialog.show(item)
    },
    async recommendMatch(project) {
      recommendMatch(project)
    },
    initHeight() {
      this.$nextTick(() => {
        if (!this.$refs.projectTableWrapper) return
        const { height } = this.$refs.projectTableWrapper.getBoundingClientRect()
        if (height > 500) {
          this.tableHeight = height - 40
        } else {
          this.tableHeight = 500
        }
      })
    },
    async getProjects(params) {
      if (this.loading) return
      this.loading = true
      const { query, radishId } = this
      const param = Object.assign(
        {
          query,
        },
        {
          paginate: {
            page: this.page,
            pageSize: this.pageSize,
          },
        },
        {
          sort: this.sort,
        },
        params,
      )
      try {
        const {
          status,
          data: { data, page, pageSize, total, message },
        } = radishId
          ? await this.$axios.get(`${window.host}/projects/list/${radishId}`, {
              params: param,
            })
          : await this.$axios.get(`${window.host}/projects/list`, {
              params: param,
            })
        if (status !== 200) {
          this.$message.error(message)
        } else {
          this.list = data
          this.page !== page && (this.page = page)
          this.pageSize !== pageSize && (this.pageSize = pageSize)
          this.total !== total && (this.total = total)
          if (!this.simple) this.getProjectsPipelines(data)
        }
      } catch (error) {
        this.$message.error(`获取项目列表出错了:${error.message}`)
      }
      this.loading = false
    },
    async getProjectsPipelines(projects) {
      if (!projects) return
      try {
        const pids = projects.map(project => project._id)
        const { data } = await this.$axios.post(`${window.host}/projects/pipelines`, {
          pids,
        })
        data.forEach(projectPipeline => {
          const project = projects.find(_project => _project._id === projectPipeline._id)
          Object.assign(project, projectPipeline)
        })
      } catch (e) {
        console.error(e)
      }
    },
    pageChange(val) {
      this.page = val
      this.getProjects()
    },
    pageSizeChange(val) {
      this.pageSize = val
      this.getProjects()
    },
    jumpToCompany() {
      this.openDrawer('targetCompany')
    },
    setQuery(query) {
      if (query) {
        this.query = Object.assign({}, query)
        this.page = 1
        this.getProjects()
      } else {
        this.query = undefined
      }
    },
    onChangeStatus(status) {
      this.modify(this.project._id, {
        项目状态: status,
      })
      this.project['项目状态'] = status
      if (status === '已失败') {
        this.openDrawer('finalRadish', this.project)
      }
    },
    async modify(id, param) {
      if (!id) return
      try {
        await window.app.service('project').modify({ id, param })
        this.$message({
          type: 'success',
          message: '修改成功',
        })
      } catch (error) {
        this.$message.error(`projectTable modify:${error.message}`)
      }
    },
    moment(date) {
      return date ? dateFormat(new Date(parseInt(date, 10)), 'yyyy-mm-dd') : ''
    },
    passed(date) {
      return date ? `${Math.ceil((Date.now() - date) / (24 * 3600 * 1000))}天` : ''
    },
    async showPipeline(row, targetId) {
      const child1 = row['面试'] || []
      const child2 = row['终面'] || []
      const child3 = row.offer || []
      const child4 = row['到岗'] || []
      const children = [child1, child2, child3, child4]
      const rids = []
      children.forEach(child => {
        child.forEach(item => {
          rids.push(item.rid)
        })
      })
      if (rids.length !== 0) {
        const res = await window.app.service('radish').list({ query: { _id: rids }, $sort: { updatedAt: -1 } })
        if (res.status !== 'success') {
          this.$message.error('radish service list error')
          return
        }
        const radishes = res.data.data
        radishes.forEach(radish => {
          children.forEach(child => {
            child.forEach(item => {
              if (radish._id === item.rid) {
                this.mergeRadish(item, radish)
              }
            })
          })
        })
      }
      this.pipelineData = Object.assign(
        {},
        {
          面试: child1,
          终面: child2,
          offer: child3,
          到岗: child4,
        },
      )
      this.popperTarget = targetId
      this.popperVisible = true
      this.popperType = 'pipeline'
    },
    showFiles(row, targetId) {
      this.files = row.files
      this.popperTarget = targetId
      this.popperVisible = true
      this.popperType = 'files'
    },
    showDropdown(row, targetId) {
      this.project = row
      this.projectReportShow = false
      this.popperVisible = true
      this.popperTarget = targetId
      this.popperType = 'dropdown'
    },
    showStatus(row, targetId) {
      this.project = row
      this.popperVisible = true
      this.popperTarget = targetId
      this.popperType = 'status'
    },
    mergeRadish(target, radish) {
      target['姓名'] = radish['姓名'] || '--'
      target['性别'] = radish['性别'] || '--'
      target['公司'] = radish['公司'] || '--'
      target['部门'] = radish['部门'] || '--'
      target['目前职位'] = radish['目前职位'] || '--'
      target['手机'] = radish['手机'] || '--'
      target['地域'] = radish['地域'] || '--'
      target['职能模块'] = radish['职能模块'] || '--'
    },
    handleSort({ column, prop, order }) {
      if (!order) {
        this.sort = {}
      } else {
        this.sort = {
          [prop || sortKeyFormat[column.label] || column.label]: order === 'ascending' ? 1 : -1,
        }
      }
      this.getProjects()
    },
    onEdit(id) {
      if (!window.app.user['角色'] || !window.app.user['角色'].includes('管理员')) return
      this.editing = id
    },
    onChangeName(project, val) {
      this.editing = ''
      if (val && project['项目名称'] !== val) {
        this.modify(project._id, { 项目名称: val.trim() })
      }
    },
    onClickName(type, keywords) {
      window.app.root.search({
        type,
        keywords,
      })
    },
    showProjectDetail() {
      this.projectDetailInfoVisible = true
    },
    copyProject() {
      // window.app.root.$refs.addProjectFull.open(this.project)
      window.open(`${window.frontend}/#/createProject20?copyPid=${this.project._id}`, '_blank')
    },
    addRadish() {
      window.app.root.$refs.radishAdd.open({ defaultPid: this.project._id })
    },
    openDrawer(type, project) {
      if (window.app.root.$refs.addRadishDrawer) {
        window.app.root.$refs.addRadishDrawer.openDrawer(type, project || this.project)
      }
    },
    async oneKeyMatch(mode) {
      try {
        await oneKeyMatch({
          mode,
          project: this.project,
          onNoResult: () => {
            this.$message('没有匹配结果')
          },
        })
      } catch (error) {
        this.$message.error(error.message)
      }
    },
    async showPipelineDetail(type, list) {
      this.pipelineDetailVisible = true
      this.pipelineDetailType = type
      if (!list || list.length === 0) return
      const rids = list.map(val => val.rid).filter(Boolean)
      if (rids.length === 0) return
      const {
        status,
        data: { data },
      } = await window.app.service('radish').list({ query: { _id: rids } })
      if (status !== 'success') return (this.pipelineDetailData = list)
      data.forEach(radish => {
        list.forEach(obj => {
          if (radish._id === obj.rid) {
            this.mergeRadish(obj, radish)
          }
        })
      })
      this.pipelineDetailData = list
    },
    showRadishPortrait() {
      app.root.$refs.RadishPortrait.open({ rid: this.radishId, project: this.project })
    },
    changeYi: async function(row, val) {
      const result = await app.service('radish').modifyYixiang({ rid: row.rid, pid: row.pid, yixiang: val })
      if (result.status == 'success') {
        this.$message.success({ duration: 500, message: '修改成功' })
      } else {
        this.$message.error(result.msg)
      }
    },
    showDeskfollowBtn() {
      const { desktopFollow = [] } = this.project
      const account = app.user.account
      const hasFollow = desktopFollow.find(val => val.account === account && val.type === 'project')
      return !!hasFollow
    },
    async addDesktopFollow() {
      const res = await app
        .service('company')
        .addDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.project.desktopFollow = res.data
        this.$message.success('关注成功')
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async deleteDesktopFollow() {
      const res = await app
        .service('company')
        .deleteDesktopFollow({ type: 'project', bindId: this.project._id, account: app.user.account })
      if (res.status === 'success') {
        this.$message.success('取消关注成功')
        this.project.desktopFollow = []
      } else this.$message.error(res.msg)
      this.popperVisible = false
    },
    async generateProjectReport() {
      const data = await app.service('project').projectRecommends(this.project._id)
      if (data && data.length > 0) {
        this.projectReportShow = true
      } else {
        this.projectReportShow = false
        this.$message.error(`当前没有推荐人选，请推荐人选之后重试`)
      }
      await app.service('project').saveRecords({ type: '生成项目报告', path: '顶部导航栏-项目操作', page: '项目详情' })
    },
  },
}
</script>

<style scoped>
.cell-multi {
  margin: 0 -5px;
}
.cell-multi-item {
  margin-right: 5px;
}
.project-table-wrapper {
  position: relative;
  height: 100%;
}
.cell .el-icon-star-on,
.project-table-wrapper .pointer {
  color: #409eff;
}
.ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ellipsis > .cell {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.ellipsis .cell-edit-input {
  width: 100%;
}

.dropdown-popper {
  border: 1px solid #eaeefb;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
}
.dropdown-popper .item {
  position: relative;
  display: block;
  width: 100%;
  padding: 10px 20px;
  color: #606266;
  background: #fff;
  cursor: pointer;
  line-height: 1;
  white-space: nowrap;
}
.dropdown-popper .item:hover {
  color: #fff;
  background: #409eff;
}
.dropdown-popper .item:hover .sub-item {
  display: block;
}
.dropdown-popper .item .sub-item {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
}
.shadow {
  box-shadow: 0px 2px 8px 0px rgba(232, 237, 250, 0.6), 0 2px 4px 2px rgba(232, 237, 250, 0.5);
}
.color-select .el-input__inner {
  background: transparent;
}
</style>
